import { render, staticRenderFns } from "./gridActions.vue?vue&type=template&id=0b70e5f4&lang=pug&"
import script from "./gridActions.vue?vue&type=script&lang=js&"
export * from "./gridActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports